export const upperCase = function (row, column) {
  return row[column.property].toUpperCase()
}

export const formatDate = function (row, column) {
  return new Date(row[column.property]).getFullYear()
}



// WEBPACK FOOTER //
// ./src/services/formatter.js